import React, {useState} from 'react';
import "./ContactForm.css";

import { Container } from "reactstrap";

const ContactForm = () => {
  const [name, onNameChange] = useState('')
  const [email, onEmailChange] = useState('')
  const [message, onMessageChange] = useState('')
  const [status, setStatus] = useState(null)

  const resetForm = () => {
    onNameChange('')
    onEmailChange('')
    onMessageChange('')
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!name.trim() || !email.trim() || !message.trim()) {
      setStatus('validation');
      return;
    }
    setStatus(null);
    fetch('https://us-central1-vajramudita-a4641.cloudfunctions.net/newEmail/send', {
        method: "POST",
        body: JSON.stringify({name: name, email: email, message: message}),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
      }).then(
      (response) => (response.json())
        ).then((response)=> {
      if (response.status === 'success') {
        setStatus('success');
        resetForm()
      } else {
        setStatus('fail');
      }
    }).catch(
      error => {
        setStatus('error');
        console.log(error)
      }
    )
  };

  return (
      <Container >
        <form id="contact-form" className='contact-form' onSubmit={event => handleSubmit(event)} method="POST" >
            <h2>Contact Us</h2>
            <div className="form-group">
                <label htmlFor="name">Name</label>
                <input type="text" className="form-control" id="name" value={name} onChange={event => onNameChange(event.target.value)} />
            </div>
            <div className="form-group">
                <label htmlFor="exampleInputEmail1">Email address</label>
                <input type="email" className="form-control" id="email" aria-describedby="emailHelp" value={email} onChange={event => onEmailChange(event.target.value)} />
            </div>
            <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea  className="form-control" rows="5" id="message" value={message} onChange={event => onMessageChange(event.target.value)} />
            </div>
            {status === 'validation' && <p className="form-status form-status--error">Please fill in all fields.</p>}
            {status === 'success' && <p className="form-status form-status--success">Message sent! We will be in touch soon.</p>}
            {status === 'fail' && <p className="form-status form-status--error">Message failed to send. Please try again.</p>}
            {status === 'error' && <p className="form-status form-status--error">Connection error. Please email us directly at <a href="mailto:vajramudita@gmail.com">vajramudita@gmail.com</a>.</p>}
            <button type="submit" className='submit' ><span>Send Message</span></button>
        </form>
      </Container>
  );
};

export default ContactForm;
